/* global messg */
import React from 'react'
import { put } from 'redux-saga/effects'
import PropTypes from 'prop-types'

import I18n from 'lib/i18n'
import createForm from 'lib/kea/create-form'
import RawField from 'lib/kea/field'
import { required, requiredEmail } from 'lib/kea/required'
import isEmailValid from 'lib/utils/is-email-valid'
import delay from 'lib/utils/delay'

import logic from '../logic'

import controller from '../controller.rb'

function invalidDate (string) {
  const [year, month, day] = string.split('-').map(s => parseInt(s))
  return !year || !month || !day
}

export const form = createForm({
  connect: {
    actions: [logic, ['signupSuccess']],
    props: [logic, ['oauthRegistration', 'needBirthday', 'formDefaults', 'skipRecaptcha', 'grecaptchaObject']]
  },

  path: () => ['scenes', 'registrationSignup', 'form'],

  inContainer: '#general-form',

  propTypes: {
    name: PropTypes.string,
    phone: PropTypes.string,
    phoneValid: PropTypes.bool,
    email: PropTypes.string,
    password: PropTypes.string,
    birthday: PropTypes.string,
    token: PropTypes.string
  },

  defaults:
    ({ selectors }) =>
    state => ({
      name: '',
      phone: '',
      phoneValid: false,
      email: '',
      password: '',
      birthday: '',
      token: null,
      ...selectors.formDefaults(state)
    }),

  validationInput: selectors => [
    selectors.values,
    selectors.oauthRegistration,
    selectors.needBirthday,
    selectors.skipRecaptcha
  ],

  validate: (values, oauthRegistration, needBirthday, skipRecaptcha) => {
    let errors = {
      name: required(values.name),
      phone: required(values.phone),
      email: requiredEmail(values.email),
      password: !oauthRegistration && required(values.password),
      birthday:
        needBirthday && (!values.birthday || invalidDate(values.birthday))
          ? I18n.t('courses.form.error_field_empty')
          : null,
      token: skipRecaptcha ? null : required(values.token)
    }

    if (!errors.name && isEmailValid(values.name)) {
      errors.name = I18n.t('devise.sessions.new_student.error_full_name_not_email')
    }

    if (!errors.name && values.name.replace('  ', ' ').trim().split(' ').length < 2) {
      errors.name = I18n.t('devise.sessions.new_student.error_no_full_name')
    }

    if (!errors.phone && !values.phoneValid) {
      errors.phone = I18n.t('errors.invalid_phone_number')
    }

    if (!oauthRegistration && !errors.password && values.password && values.password.length < 8) {
      errors.password = I18n.t('devise.sessions.new_student.error_password_short')
    }

    return errors
  },

  manualValidation: function * (key, value) {
    const { clearErrorsForField, mergeErrors, showErrorsForField } = this.actions

    const validationErrors = yield this.get('validationErrors')

    if (key === 'email' && !validationErrors.email) {
      yield put(clearErrorsForField('email'))

      try {
        yield delay(200)
        const response = yield controller.checkEmail({ email: value })

        if (response.error) {
          yield put(mergeErrors({ email: response.error }))
          yield put(showErrorsForField('email'))
        } else {
          yield put(mergeErrors({ email: null }))
        }
      } catch (error) {
        yield put(mergeErrors({ email: error.message }))
        yield put(showErrorsForField('email'))
      }
    }

    if (key === 'phone' && !validationErrors.phone) {
      yield put(clearErrorsForField('phone'))

      try {
        yield delay(200)
        const values = yield this.get('values')
        const response = yield controller.checkPhone({ phone: value, email: values.email })

        if (response.error) {
          yield put(mergeErrors({ phone: response.error }))
          yield put(showErrorsForField('phone'))
        } else {
          yield put(mergeErrors({ phone: null }))
        }
      } catch (error) {
        yield put(mergeErrors({ phone: error.message }))
        yield put(showErrorsForField('phone'))
      }
    }
  },

  submit: function * () {
    const { mergeErrors } = this.actions

    const values = yield this.get('values')
    const grecaptchaObject = yield this.get('grecaptchaObject')

    const response = yield controller.createAccount({ ...values })

    if (response.success) {
      return response
    } else if (response.errors) {
      grecaptchaObject.reset()
      yield put(mergeErrors(response.errors))
    } else if (response.error) {
      grecaptchaObject.reset()
      yield put(mergeErrors(response.error))
    }
  },

  success: function * (response) {
    const { signupSuccess } = this.actions

    const redirectUrl = response.redirect

    if (typeof window !== 'undefined' && window.fbq) {
      window.fbq('track', 'CompleteRegistration', { value: 0.0, currency: response.currency })
      yield delay(100)
    }

    window.location.href = redirectUrl

    // just in case do it one more time
    window.setTimeout(() => {
      window.location.href = redirectUrl
    }, 15000)

    yield put(signupSuccess(response.redirect))
  },

  failure: function * () {
    const { setValue } = this.actions
    yield put(setValue('token', null))
    messg.error(I18n.t('modals.error_text'), 2500)
  }
})

const ClonedField = ({ ...props }) => <RawField {...props} />

export const Field = form(ClonedField)
